import React from 'react';
import {M250Carousel} from './m250-carousel';
import {IM250CarouselModule} from '~/lib/data-contract';

export const M250CarouselBlock = ({
                                      id,
                                      headline,
                                      carouselItems,
                                      autoPlay,
                                      autoPlayInterval,
                                      numberOfVisibleSlides,
                                      orientation,
                                      height,
                                  }: IM250CarouselModule) => {
    return (
        <M250Carousel
            id={id}
            headline={headline}
            carouselItems={carouselItems}
            autoPlay={autoPlay}
            autoPlayInterval={autoPlayInterval}
            numberOfVisibleSlides={numberOfVisibleSlides}
            orientation={orientation}
            height={height}
        />
    );
};